import React from 'react';
import {
  Box,
  Button,
  Chip,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { DataGrid } from '../common/datagrid/ResponsiveDataGrid';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const DOC_TYPE_LABELS = {
  HR_LEAVE: '휴가 신청',
  ORDER_BOOK: '수주품의서',
};

const ApprovalLineTemplateTab = ({
  list,
  loading,
  docTypeFilter,
  onDocTypeFilterChange,
  onAdd,
  onEdit,
  onDelete,
}) => {
  const columns = [
    {
      field: 'lineNm',
      headerName: '템플릿명',
      minWidth: 180,
      flex: 1,
    },
    {
      field: 'docType',
      headerName: '대상 문서',
      minWidth: 120,
      flex: 0.6,
      renderCell: ({ value }) => DOC_TYPE_LABELS[value] || '공통',
    },
    {
      field: 'stepCount',
      headerName: '단계 수',
      minWidth: 90,
      flex: 0.4,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: (value) => `${value || 0}단계`,
    },
    {
      field: 'steps',
      headerName: '결재 흐름',
      minWidth: 320,
      flex: 1.5,
      sortable: false,
      renderCell: ({ value }) => (
        <Stack direction="row" spacing={0.5} sx={{ flexWrap: 'wrap', py: 0.5 }}>
          {(value || []).map((step) => (
            <Chip
              key={step.lineStepId || `${step.stepOrder}-${step.assigneeUsrUuid}`}
              label={`${step.stepOrder}차 ${step.assigneeUsrNm || step.assigneeUsrUuid}`}
              size="small"
              variant="outlined"
            />
          ))}
        </Stack>
      ),
    },
    {
      field: 'useYn',
      headerName: '상태',
      minWidth: 90,
      flex: 0.4,
      renderCell: ({ value }) => (
        <Chip
          label={value === 'Y' ? '사용중' : '비활성'}
          color={value === 'Y' ? 'success' : 'default'}
          size="small"
        />
      ),
    },
    {
      field: 'actions',
      headerName: '',
      minWidth: 110,
      sortable: false,
      renderCell: ({ row }) => (
        <Stack direction="row" spacing={0.5}>
          <Tooltip title="수정">
            <IconButton size="small" color="primary" onClick={() => onEdit(row)}>
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="삭제">
            <IconButton size="small" color="error" onClick={() => onDelete(row)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      ),
    },
  ];

  return (
    <Box>
      <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
        <Box>
          <Typography variant="body2" fontWeight={600}>
            V2 결재선 템플릿
          </Typography>
          <Typography variant="caption" color="text.secondary">
            legacy 결재선이 아니라 approval v2 전용 템플릿입니다. 휴가 신청과 수주품의서에서 바로 선택할 수 있습니다.
          </Typography>
        </Box>
        <Box sx={{ flex: 1 }} />
        <TextField
          select
          size="small"
          label="대상 문서"
          value={docTypeFilter}
          onChange={(event) => onDocTypeFilterChange(event.target.value)}
          sx={{ width: 160 }}
        >
          <MenuItem value="">전체</MenuItem>
          <MenuItem value="HR_LEAVE">휴가 신청</MenuItem>
          <MenuItem value="ORDER_BOOK">수주품의서</MenuItem>
        </TextField>
        <Button variant="contained" size="small" startIcon={<AddIcon />} onClick={onAdd}>
          템플릿 등록
        </Button>
      </Stack>

      <DataGrid
        rows={list}
        columns={columns}
        getRowId={(row) => row.lineId}
        loading={loading}
        autoHeight
        density="compact"
        disableRowSelectionOnClick
        sx={{ bgcolor: 'background.paper', borderRadius: 1 }}
      />
    </Box>
  );
};

export default ApprovalLineTemplateTab;
